import { createFileRoute } from "@tanstack/react-router";

import { AppShell } from "@/components/app/app-shell";
import { MasterCalendar } from "@/components/app/master-calendar";

export const Route = createFileRoute("/_authenticated/calendar")({
  head: () => ({
    meta: [
      { title: "Master Calendar | Warrior Volunteer" },
      {
        name: "description",
        content: "Every T1D Warriors volunteer event and golf outing on one calendar.",
      },
      { property: "og:title", content: "Master Calendar | Warrior Volunteer" },
      {
        property: "og:description",
        content: "Every T1D Warriors volunteer event and golf outing on one calendar.",
      },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: CalendarPage,
});

function CalendarPage() {
  return (
    <AppShell
      title="Master calendar"
      eyebrow="Schedule"
    >
      <MasterCalendar />
    </AppShell>
  );
}
